export enum CleaningType {
    BASIC_CLEANING = 'regular cleaning',
    DEEP_CLEANING = 'deep cleaning',
    SPRING_CLEANING = 'spring cleaning',
    MOVE_IN_OUT_CLEANING = 'move-in/out cleaning',
    CUSTOM_CLEANING = 'custom cleaning'
  }
  